<template>
  <router-view v-if="routedSong" />
  <transition-fade v-else :duration="500" appear>
    <media-archive
      v-if="activeSchoolLevel?.archivedSongs.length"
      :items="activeSchoolLevel?.archivedSongs"
      fade-out
      v-slot="{ items }"
    >
      <!-- Other than in FilmArchive there is no list transition here.
           There's just too many items for that. -->

      <div v-for="item in items" :key="item.slug">
        <div
          :key="item.slug"
          class="song-list__song-item song-list__song-item--search-result border-0 border-r-2 border-solid border-r-black/20 max-w-none px-[10px]"
        >
          <router-link
            :to="{
              name: 'MusicArchiveKaraokePlayer',
              params: {
                volumeSlug: activeVolume.slug,
                schoolLevelSlug: activeSchoolLevel.slug,
                songSlug: item.slug,
              },
            }"
            class="song-list__song-item__link items-center bg-white border-0 border-b border-solid border-b-orange-500/20 text-black flex justify-between py-[7px] px-[10px] no-underline scale-100 transition-all duration-300 ease-[cubic-bezier(.25,.8,.25,1)] hover:bg-hover hover:scale-[1.02] hover:ease-[ease]"
          >
            <div
              class="song-list__song-item__title grow text-[17px] font-light py-0 pr-[20px] pl-[20px]"
            >
              {{ item.title }}
            </div>
            <div
              class="song-list__song-item__duration text-orange-500/50 text-[11px] tracking-[-0.4px] py-0 px-[20px]"
            >
              {{
                (item.vocalMix ?? item.karaokeSoundMix)?.durationFormatted ||
                "00:00"
              }}
            </div>
          </router-link>
        </div>
      </div>
    </media-archive>
    <div v-else class="flex h-full justify-center items-center">
      <box-generic header="Geen materiaal">
        <p class="mt-3 leading-relaxed">Er zijn geen liedjes beschikbaar.</p>
      </box-generic>
    </div>
  </transition-fade>
</template>

<script>
import { mapGetters } from "vuex";

import { RouterLink } from "vue-router";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import MediaArchive from "../../../../components/content/archive/MediaArchive.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

export default {
  name: "MusicArchive",
  components: {
    BoxGeneric,
    MediaArchive,
    RouterLink,
    TransitionFade,
  },
  computed: {
    ...mapGetters(["activeSchoolLevel", "activeVolume", "routedSong"]),
  },
};
</script>
